export enum QuantityType {
  Cases = 'CS',
  Eaches = 'EA',
}
